export class StorageUtils {
  public static get idxIntervals(): NodeJS.Timeout[] {
    const item = localStorage.getItem(LSItem.intervals);
    return item && JSON.parse(item) || [];
  }

  public static set idxInterval(idx: NodeJS.Timeout) {
    localStorage.setItem(LSItem.intervals, JSON.stringify(StorageUtils.idxIntervals.concat(idx)));
  }

  public static get reload(): string {
    return localStorage.getItem(LSItem.reload) ?? '';
  }

  public static set reload(key: string) {
    localStorage.setItem(LSItem.reload, key);
  }
}

export enum LSItem {
  token = 'token',
  tokenRules = 'tokenRules',
  intervals = 'intervals',
  eventKey = 'eventKey',
  reload = 'reload',
  version = 'version',
  ctUrl = 'ctUrl',
  ctCheckUrl = 'ctCheckUrl',
  nickname = 'nickname',
  email = 'email',
  empresa = 'empresa',
  nomeEmpresa = 'nomeEmpresa',
  linkLogo = 'linkLogo',
}
